/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, NotificationTypeFromJSON, NotificationTypeToJSON, TimeSpanFromJSON, TimeSpanToJSON, } from './';
export function NotificationRecurringFromJSON(json) {
    return NotificationRecurringFromJSONTyped(json, false);
}
export function NotificationRecurringFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'content': !exists(json, 'content') ? undefined : json['content'],
        'eventStartDate': !exists(json, 'eventStartDate') ? undefined : (new Date(json['eventStartDate'])),
        'eventEndDate': !exists(json, 'eventEndDate') ? undefined : (json['eventEndDate'] === null ? null : new Date(json['eventEndDate'])),
        'interval': !exists(json, 'interval') ? undefined : TimeSpanFromJSON(json['interval']),
        'notifyAheadTime': !exists(json, 'notifyAheadTime') ? undefined : TimeSpanFromJSON(json['notifyAheadTime']),
        'type': !exists(json, 'type') ? undefined : NotificationTypeFromJSON(json['type']),
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'user': !exists(json, 'user') ? undefined : ApplicationUserFromJSON(json['user']),
        'sourceObjectId': !exists(json, 'sourceObjectId') ? undefined : json['sourceObjectId'],
        'sourceObjectType': !exists(json, 'sourceObjectType') ? undefined : json['sourceObjectType'],
    };
}
export function NotificationRecurringToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'content': value.content,
        'eventStartDate': value.eventStartDate === undefined ? undefined : (value.eventStartDate.toISOString()),
        'eventEndDate': value.eventEndDate === undefined ? undefined : (value.eventEndDate === null ? null : value.eventEndDate.toISOString()),
        'interval': TimeSpanToJSON(value.interval),
        'notifyAheadTime': TimeSpanToJSON(value.notifyAheadTime),
        'type': NotificationTypeToJSON(value.type),
        'userId': value.userId,
        'user': ApplicationUserToJSON(value.user),
        'sourceObjectId': value.sourceObjectId,
        'sourceObjectType': value.sourceObjectType,
    };
}
